import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { TenantConfigurationComponent } from './tenant-configuration.component';
import { TenantConfigurationService } from './tenant-configuration.service';
import { CalendarModule, DataTableModule } from 'primeng/primeng';
import { FormsModule } from '@angular/forms';

import { SharedModule } from 'app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    CalendarModule,
    DataTableModule,
    SharedModule,
    FormsModule,
    MaterialModule.forRoot()
  ],
  declarations: [
    TenantConfigurationComponent
  ],
  providers: [
    TenantConfigurationService
  ]
})
export class TenantConfigurationModule { }



// WEBPACK FOOTER //
// ./src/app/admin/tenantconfiguration/tenant-configuration.module.ts